module.exports = __webpack_public_path__ + "media/admin/asset-manager/assets/no-result-5098836a96bc69495e8f967b3ad1f26c.svg";